import React from 'react'

const Header = () => {
  return (
    <div>
      <header className="posts-header">Posts</header>
    </div>
  );
}

export default Header